<template>
  <div v-for="type in types" :key="type.id">
    <div
      class="type hover-block"
      @mousemove="handleMouseMove($event)"
      @mouseenter="handleMouseEnter(type.id)"
      @mouseleave="handleMouseLeave(type.id)"
      @click="openModal(type)"
    >
      <span class="corner corner-top-left"></span>
      <span class="corner corner-top-right"></span>
      <span class="corner corner-bottom-left"></span>
      <span class="corner corner-bottom-right"></span>
      <img
        v-if="hoveredType === type.id"
        :style="imageStyle"
        :src="getImageTeamPath(type.img)"
        alt="Hover image"
        class="hover-image"
      />
      <div class="type__title">
        <div class="types">{{ type.type }}</div>
        <img class="wings" :src="getImageTeamPath(type.img)" alt="icon" />
        <div class="title">{{ type.description }}</div>
        <img
          class="arrow"
          src="@/assets/images/icons/arrow-black.png"
          alt="icon"
        />
      </div>
    </div>
    <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <button class="modal-close" @click="closeModal">×</button>
        <img
          v-if="selectedType"
          :src="getImageTeamPath(selectedType.img)"
          alt="Modal image"
          class="modal-image"
        />
        <div class="modal-text">
          <img src="@/assets/images/icons/logo-modal.svg" alt="icon" />
          <h3>{{ selectedType.type }}</h3>
          <p>{{ selectedType.descriptionModal }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uav-types-item",
  props: {
    types: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showImage: true,
      mouseX: 0,
      mouseY: 0,
      hoveredType: null,
      isModalOpen: false,
      selectedType: null,
    };
  },
  computed: {
    imageStyle() {
      return {
        position: "fixed",
        left: `${this.mouseX - 75}px`,
        top: `${this.mouseY - 40}px`,
        pointerEvents: "none",
        transform: "translate(0, 0)",
        willChange: "left, top",
      };
    },
  },
  methods: {
    openModal(type) {
      this.selectedType = type;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.selectedType = null;
    },
    getImageTeamPath(item) {
      return require(`@/assets/images/uav/${item}.png`);
    },
    handleMouseMove(event) {
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;
    },
    handleMouseEnter(typeId) {
      this.hoveredType = typeId;
    },
    handleMouseLeave() {
      this.hoveredType = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.type {
  margin: 0 auto;
  width: 100%;
  padding: 10px 0;
  position: relative;

  @media (max-width: 767px) {
    width: 345px;
    height: 480px;
    position: relative;
    border: 1px solid #1c1c1c;
  }

  &__title {
    border-bottom: 1px solid white;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    padding: 0 10px;
    height: 140px;
    justify-content: space-between;

    @media (max-width: 767px) {
      height: 480px !important;
    }

    @media (max-width: 1360px) {
      flex-direction: column;
      height: unset;
      align-items: flex-start;
      position: relative;
      gap: 15px;
    }

    &:first-child {
      border-top: 1px solid white;
    }

    .types {
      width: 224px;
      font-family: UAF Sans;
      font-weight: 500;
      font-size: 32px;
      line-height: 100%;
      letter-spacing: 0%;
      text-transform: uppercase;
      text-align: left;
    }

    .title {
      width: 500px;
      text-align: left;
      margin-left: 37px;

      @media (max-width: 767px) {
        width: 100%;
        font-size: 18px;
        //position: absolute;
        //bottom: 0;
      }

      @media (max-width: 1360px) {
        margin-left: 0;
      }
    }

    img.arrow {
      width: 40px;
      padding: 42px;

      @media (max-width: 1360px) {
        position: absolute;
        top: 0px;
        right: 10px;
        padding: 0;
      }
    }
  }
  .wings {
    display: none;

    @media (max-width: 767px) {
      width: 100% !important;
      margin: 60px 0;
    }
    @media (max-width: 1360px) {
      display: block;
      width: 50%;
      object-fit: cover;
    }
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  width: 700px;
  height: 452px;
  background: #1c1c1c;
  display: flex;
  gap: 15px;
  position: relative;
  border-radius: 8px;
  overflow-y: auto;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  border: 1px solid #fff;
  align-items: center;

  @media (max-width: 767px) {
    width: 90%;
    flex-direction: column;
    height: 700px;
    justify-content: space-around;
  }
}

.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  background: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
}

.modal-image {
  width: 100%;
  max-height: 110px;
  object-fit: cover;
  margin-bottom: 15px;
}

.modal-text {
  text-align: left;
  color: white;
}

.modal-text h3 {
  font-family: "UAF Sans H", serif;
  font-weight: 500;
  font-size: 28px;
  line-height: 100%;
  margin: 8px 0 24px;
}

.modal-text p {
  font-family: "UAF Sans", serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 100%;

  @media (max-width: 767px) {
    word-break: break-all;
  }
}

.corner {
  position: absolute;
  width: 10px;
  height: 10px;

  @media (max-width: 767px) {
    display: none;
  }
}

.corner-top-left {
  top: 0;
  left: 0;
  border-top: 2px solid black;
  border-left: 2px solid black;
}

.corner-top-right {
  top: 0;
  right: 0;
  border-top: 2px solid black;
  border-right: 2px solid black;
}

.corner-bottom-left {
  bottom: 0;
  left: 0;
  border-bottom: 2px solid black;
  border-left: 2px solid black;
}

.corner-bottom-right {
  bottom: 0;
  right: 0;
  border-bottom: 2px solid black;
  border-right: 2px solid black;
}
</style>
